import { render, staticRenderFns } from "./immunofingerprint.vue?vue&type=template&id=a812a3c4&scoped=true"
import script from "./immunofingerprint.vue?vue&type=script&lang=js"
export * from "./immunofingerprint.vue?vue&type=script&lang=js"
import style0 from "./immunofingerprint.vue?vue&type=style&index=0&id=a812a3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a812a3c4",
  null
  
)

export default component.exports